import { useEffect, useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { cancelExperience } from "../../Store/Action";
import { Link } from "react-router-dom";
import { differenceInDays, parse } from "date-fns";
import CardExperience from "@/Components/MyPage/CardExperience";
import { XCircle } from "lucide-react";

const S3_URL = import.meta.env.VITE_S3_URL;

function ListExperience({ dataExperience }) {
  const dispatch = useDispatch();
  const [showCancel, setShowCancel] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCancel = async (campaignId, isFamtour) => {
    const dataCancel = isFamtour ? {
        fam_tour_id: +campaignId,
      }
        :
      {
        subscription_id: +campaignId,
        user_id: 0,
      }

    const result = await dispatch(cancelExperience(dataCancel, isFamtour));

    if (result.success) {
      window.location.reload();
    } else {
      alert(`신청취소에 실패했습니다. 다시 시도해주세요. (${result.error})`);
    }
  };

  const toggleCancelButton = (id) => {
    setShowCancel((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle visibilitas tombol cancel
    }));
  };

  const diffDays = useCallback((date) => {
    const today = new Date();
    let expiredDate =
      typeof date === "string" ? parse(date, "yy-MM-dd", new Date()) : date;
    const diff = differenceInDays(expiredDate, today);
    return {
      txt: diff > 1 ? `${diff}일 남음` : diff === 1 ? "D-DAY" : "발표마감",
      diff,
    };
  }, []);

  return (
    <div className="flex mt-5 pb-10">
      <div className="gap-6 w-full">
        {dataExperience.length > 0 ? (
          dataExperience.map((item, index) => {
            const data = item.campaigns || item;

            // Famtour campaigns grouping
            if(Array.isArray(data) && data.length > 0) {
              return <div className="border border-1 border-[#C9C9C9] rounded-md">
                <div className="flex justify-between mx-3 mt-2">
                  <a href={`/detailFamtour/${data[0].fam_tour_id}`} className="font-bold text-[12px] text-[#46B6D0]">{data?.[0].fam_tour_title}</a>
                  <div className="w-1/12 relative flex flex-col items-end justify-start">
                    <button
                      className="flex items-center gap-2 text-[9px] bg-[#fe7070] rounded-full shadow-sm px-2 border transition-colors text-white font-medium"
                      onClick={() => toggleCancelButton?.(data?.[0].fam_tour_id)}
                    >
                      <XCircle width={12} />
                      <div className="flex justify-between px-1">
                        <div>취</div>
                        <div>소</div>
                      </div>
                    </button>
                    {showCancel?.[data?.[0].fam_tour_id] && (
                      <button
                        onClick={() => handleCancel?.(data?.[0].fam_tour_id, true)}
                        className="absolute top-8 right-0 bg-red-500 text-[9px] rounded-md shadow py-1 border transition-all text-white font-medium min-w-[90px] whitespace-nowrap text-center"
                      >
                        취소하시겠습니까?
                      </button>
                    )}
                  </div>
                </div>
                {
                  data.map((famtour, i) => {
                    const { txt, diff } = diffDays(famtour.announcement);
                    const rewardText = famtour.reward?.replace(/<[^>]*>?/g, "")?.replace(/&nbsp;/g, " ");

                    return <CardExperience
                      key={i}
                      item={famtour}
                      diff={diff}
                      rewardText={rewardText}
                    />
                  })
                }
              </div>
            }
            else{
              const { txt, diff } = diffDays(data.announcement);
              const rewardText = data.reward
                .replace(/<[^>]*>?/g, "")
                .replace(/&nbsp;/g, " ");

              return (
                <CardExperience
                  key={index}
                  item={item}
                  diff={diff}
                  rewardText={rewardText}
                  showCancel={showCancel}
                  toggleCancel={toggleCancelButton}
                  handleCancel={handleCancel}
                  withCancel={true}
                />
              );
            }
          })
        ) : (
          <div className="text-[12px] text-center text-[#999999] items-center justify-center py-10">
            <p className="">신청한 캠페인이 없습니다.</p>
            <p className="mt-1">다양한 캠페인에 신청해보세요:)</p>
            <Link to={"/"}>
              <button className="border text-[12px] bg-[#E8EAF9] mt-3 text-[#0F1E6C] rounded-full px-3 py-2">
                <p>캠페인 신청하러가기</p>
              </button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default ListExperience;
